<template>
  <div class="mails-container">
    <h1 class="title is-5">Mails</h1>
    <div class="eml-email card">
      <header class="eml-email-header card-header">
        <div class="eml-header-title">
          <p class="title is-6">Email subject 1</p>
          <div class="actions">
            <a href="#">Add to work</a>
            <span>
              <span class="icon"><i class="fa fa-user"></i></span>
              <span>Contact</span>
            </span>
          </div>
        </div>
        <div class="header-buttons">
          <a class="header-button navbar-item between-center">
            <o-icon pack="fa" icon="briefcase"> </o-icon>
          </a>
          <a class="header-button navbar-item between-center">
            <o-icon pack="fa" icon="check"> </o-icon>
          </a>
          <o-dropdown position="bottom-left">
            <a class="header-button navbar-item between-center" slot="trigger">
              <o-icon pack="fa" icon="ellipsis-h"> </o-icon>
            </a>
            <o-dropdown-item has-link>
              <a href="#" @click.prevent="handle('reply')">Reply</a>
            </o-dropdown-item>
            <o-dropdown-item has-link>
              <a href="#" @click.prevent="handle('replyAll')">Reply All</a>
            </o-dropdown-item>
            <o-dropdown-item has-link>
              <a href="#" @click.prevent="handle('addComment')"
                >Add A Comment</a
              >
            </o-dropdown-item>
            <hr class="dropdown-divider" />
            <o-dropdown-item has-link>
              <a href="#" @click.prevent="handle('addToProposal')"
                >Add To Proposal</a
              >
            </o-dropdown-item>
            <o-dropdown-item has-link>
              <a href="#" @click.prevent="handle('addToContact')"
                >Add To Contact</a
              >
            </o-dropdown-item>
          </o-dropdown>
        </div>
      </header>

      <div class="eml-email-content card-content1">
        <div class="eml-message-box-ctn">
          <message-box />
          <reply-box v-if="replyBoxActive" @cancel="handleCancelReply" />
          <div v-else></div>
        </div>
        <div class="eml-controls-box-ctn right">
          <mail-controls-box />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageBox from "./MessageBox"
import ReplyBox from "./ReplyBox.vue"
import MailControlsBox from "./MailControlsBox.vue"

export default {
  components: { MailControlsBox, MessageBox, ReplyBox },
  computed: {
  },
  data() {
    return {
      replyBoxActive: false,
    }
  },
  methods: {
    handleCancelReply() {
      this.replyBoxActive = false
    },
    handle(type) {
      switch (type) {
        case "cancelReply":
          this.replyBoxActive = false
        case "reply":
        case "replyAll":
          this.replyBoxActive = true
          break
        default:
          break
      }
    },
  },
  mounted() {
  }
}
</script>

<style lang="sass" scoped>
.mails-container
  .eml-email
    background-color: #ffffff
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.1)
    color: #4a4a4a
    max-width: 100%
    position: relative
    .eml-email-header
      align-items: stretch
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
      display: flex
      .eml-header-title
        align-items: flex-start
        color: #363636
        display: flex
        flex-direction: column
        flex-grow: 1
        font-weight: 550
        padding: 0.75rem
        .title
          margin-bottom: 8px
          padding-bottom: 0
        .actions
          > *:first-child
            margin-right: 12px
          .icon
            width: auto
      .header-buttons
        align-items: flex-start
        display: flex
        padding: 0.75rem
        .header-button
          height: 36px
          justify-content: center
          width: 36px
        >.header-button:after
          background: silver
          content: ''
          display: block
          height: 21px
          margin-left: 37px
          margin-top: 0px
          margin-right: 2px
          position: absolute
          width: 1px
        .dropdown
          flex-grow: 0
    .eml-email-content
      display: flex
      padding: 0.75rem
      .eml-message-box-ctn
        border-right: 1px solid rgba(0, 0, 0, 0.1)
        flex: 1px
        padding-right: 0.75rem
      .eml-controls-box-ctn
        padding-left: 0.75rem
</style>